import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { LockKeyhole, Mail } from 'lucide-react';
import { useAuth } from '../auth';
import { ApiClientError } from '../api';
import { Logo } from '../components/Logo';
import { useToast } from '../components/Toast';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { show } = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate('/', { replace: true });
    } catch (error) {
      show(error instanceof ApiClientError ? error.message : 'Không thể đăng nhập.', 'error');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page auth-page--login">
      <div className="auth-hero">
        <Logo />
        <div className="mascot" aria-hidden="true">🦕</div>
        <h1>Chào mừng bạn trở lại</h1>
        <p>Mỗi ghi nhận nhỏ hôm nay sẽ góp thành một hành trình lớn của con.</p>
      </div>
      <form className="auth-card" onSubmit={submit}>
        <label>
          Email
          <span className="input-with-icon"><Mail size={19} /><input required type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} /></span>
        </label>
        <label>
          Mật khẩu
          <span className="input-with-icon"><LockKeyhole size={19} /><input required type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} /></span>
        </label>
        <button className="button button--primary button--wide" disabled={busy} type="submit">
          {busy ? 'Đang đăng nhập…' : 'Đăng nhập'}
        </button>
      </form>
    </div>
  );
}
